import React from "react";
import { DownloadLinkBox, TextBox, List, useTranslator } from "@sia/style-guide";

const Introduction = () => {
  const currentYear = new Date().getFullYear();
  const translate = useTranslator();
  const actual_year_text = translate("account.customer-data.bbf.introduction.date");
  const actual_year_text_formatted = actual_year_text.replace("{actual_year}", currentYear);
  return (
    <div>
      <p id="introduction" className="sia-text-03">
        {translate("account.customer-data.bbf.introduction.title")}
      </p>
      <DownloadLinkBox
        title=""
        lang="de"
        items={[
          {
            link: {
              url: translate("account.customer-data.bbf.introduction.link1.url"),
              original_url: translate("account.customer-data.bbf.introduction.link1.url"),
              title: translate("account.customer-data.bbf.introduction.link1.label"),
            },
          },
          {
            link: {
              url: translate("account.customer-data.bbf.introduction.link2.url"),
              original_url: translate("account.customer-data.bbf.introduction.link2.url"),
              title: translate("account.customer-data.bbf.introduction.link2.label"),
            },
          },
        ]}
      />
      <TextBox
        items={[
          {
            paragraph_type: "text_box_title",
            title_color: {
              name: "SIAblack",
            },
            text_box_title: translate("account.customer-data.bbf.introduction.keydate"),
          },
          {
            paragraph_type: "text_box_paragraph",
            paragraph: actual_year_text_formatted,
            paragraph_color: {
              name: "SIAblack",
            },
          },
        ]}
      />

      <List
        title={translate("account.customer-data.bbf.introduction.list1.title")}
        items={[
          {
            content: translate("account.customer-data.bbf.introduction.list1.item1"),
          },
          {
            content: translate("account.customer-data.bbf.introduction.list1.item2"),
          },
          {
            content: translate("account.customer-data.bbf.introduction.list1.item3"),
          },
        ]}
        variant="UNORDERED"
        lang="de"
      />
      <List
        title={translate("account.customer-data.bbf.introduction.list2.title")}
        items={[
          {
            content: translate("account.customer-data.bbf.introduction.list2.item1"),
            children: [
              {
                content: translate("account.customer-data.bbf.introduction.list2.item1.subitem1"),
              },
              {
                content: translate("account.customer-data.bbf.introduction.list2.item1.subitem2"),
              },
              {
                content: translate("account.customer-data.bbf.introduction.list2.item1.subitem3"),
              },
              {
                content: translate("account.customer-data.bbf.introduction.list2.item1.subitem4"),
              },
              {
                content: translate("account.customer-data.bbf.introduction.list2.item1.subitem5"),
              },
            ],
          },
          {
            content: translate("account.customer-data.bbf.introduction.list2.item2"),
            children: [
              {
                content: translate("account.customer-data.bbf.introduction.list2.item2.subitem1"),
              },
            ],
          },
        ]}
        variant="UNORDERED"
        lang="de"
      />
    </div>
  );
};

export default Introduction;
